import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setStatus('error');
      return;
    }
    
    setStatus('loading');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 4000);
    }, 1200);
  };

  return (
    <footer className="bg-moon-white pt-24 pb-12 px-6 border-t border-tea-stone/50">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-20">
        
        <div className="lg:col-span-2 pr-0 lg:pr-12">
          <h3 className="font-serif text-3xl text-plum-dark mb-6">LunaBrew</h3>
          <p className="text-gray-500 text-sm leading-relaxed max-w-md mb-8">
            Curating moments of stillness through exceptional teas and thoughtfully crafted teaware. Elevate your daily ritual.
          </p>
          <form className="flex flex-col max-w-md relative" onSubmit={handleSubscribe} noValidate>
            <div className="relative">
              <input 
                type="email" 
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (status === 'error') setStatus('idle');
                }}
                placeholder="Join our newsletter" 
                aria-label="Email address for newsletter"
                disabled={status === 'loading' || status === 'success'}
                className={`bg-transparent border-b py-3 pr-28 outline-none transition-colors w-full text-sm text-gray-700 placeholder-gray-400 focus-visible:border-jade disabled:opacity-50
                  ${status === 'error' ? 'border-red-400' : 'border-gray-300'}
                `}
              />
              <button 
                type="submit"
                disabled={status === 'loading' || status === 'success'}
                className="absolute right-0 bottom-0 py-3 px-2 text-jade uppercase tracking-[0.2em] text-[10px] font-bold hover:text-plum-dark transition-colors disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm"
              >
                {status === 'loading' ? 'Joining...' : status === 'success' ? 'Joined!' : 'Subscribe'}
              </button>
            </div>
            {status === 'error' && (
              <p className="text-red-500 text-xs mt-2 absolute -bottom-6">Please enter a valid email address.</p>
            )}
            {status === 'success' && (
              <p className="text-jade text-xs mt-2 absolute -bottom-6" aria-live="polite">Welcome to our community. Check your inbox soon.</p>
            )}
          </form>
        </div>
        
        <div>
          <h4 className="font-sans text-xs uppercase tracking-[0.2em] font-bold text-plum-dark mb-6">Explore</h4>
          <ul className="space-y-4 text-gray-500 text-sm">
            <li><a href="#shop" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm px-1 -ml-1">All Teas</a></li>
            <li><a href="#teaware" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm px-1 -ml-1">Teaware</a></li>
            <li><a href="#origins" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm px-1 -ml-1">Our Origins</a></li>
            <li><a href="#guide" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm px-1 -ml-1">Brewing Guide</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-sans text-xs uppercase tracking-[0.2em] font-bold text-plum-dark mb-6">Support</h4>
          <ul className="space-y-4 text-gray-500 text-sm">
            <li><a href="#" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm px-1 -ml-1">Contact Us</a></li>
            <li><a href="#" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm px-1 -ml-1">Shipping & Returns</a></li>
            <li><a href="#" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm px-1 -ml-1">FAQ</a></li>
            <li><a href="#" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm px-1 -ml-1">Wholesale</a></li>
          </ul>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center pt-8 border-t border-tea-stone/50 text-[10px] text-gray-400 uppercase tracking-[0.1em]">
        <p className="mb-4 md:mb-0">&copy; {new Date().getFullYear()} LunaBrew Tea House. All rights reserved.</p>
        <div className="flex items-center space-x-6">
          <a href="#" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm p-1">Privacy</a>
          <a href="#" className="hover:text-jade transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-jade rounded-sm p-1">Terms</a>
          <span className="text-gray-300" aria-hidden="true">|</span>
          <p className="text-center" style={{ textTransform: 'none' }}><span>Made by </span><a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>DigLab.ai</a><span> and </span><a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" style={{ textTransform: 'none' }}>LingLinkAI.cn</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;